<template>
  <vx-card>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <div class="p-6">
        <vs-row class="mb-6">
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
            <ValidationProvider
              :rules="`required`"
              name="name"
              v-slot="{ errors }"
            >
              <vs-input
                type="text"
                class="w-full"
                label="name"
                v-model="form.name"
              />
              <span class="text-danger text-sm" v-show="errors">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </vs-col>
        </vs-row>

        <vs-row class="mb-6">
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12">
            <ValidationProvider
              :rules="`max:500`"
              name="description"
              v-slot="{ errors }"
            >
              <vs-input
                type="text"
                class="w-full"
                label="description"
                v-model="form.description"
              />
              <span class="text-danger text-sm" v-show="errors">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </vs-col>
        </vs-row>

        <ValidationProvider
          rules="required"
          name="permissions"
          v-slot="{ errors }"
          tag="div"
        >
          <vx-card class="mt-base" title="Permissions" no-shadow card-border>
            <ul>
              <li
                v-for="(permission, index) in permissions"
                :key="index"
                class="vx-row mb-1"
              >
                <vs-checkbox
                  :vs-value="permission.id"
                  v-model="form.permissions"
                >
                  {{ permission.name }}
                </vs-checkbox>
              </li>
            </ul>
            <span class="text-danger text-sm" v-show="errors">
              {{ errors[0] }}
            </span>
          </vx-card>
        </ValidationProvider>
      </div>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="handleSubmit" :disabled="invalid">
          Submit
        </vs-button>
      </div>
    </ValidationObserver>
  </vx-card>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import DropZone from "@/components/DropZone";
import { mapActions, mapState } from "vuex";
import { snakeCase } from "lodash";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    DropZone,
  },
  data() {
    return {
      form: {
        permissions: [],
        name: "",
        description: "",
      },
    };
  },
  computed: {
    ...mapState({
      permissions: ({ adminRoleManagement }) => adminRoleManagement.permissions,
      adminRole: ({ adminRoleManagement }) => adminRoleManagement.adminRole,
      addAdminRoleState: ({ adminRoleManagement }) =>
        adminRoleManagement.apiState.addAdminRole,
      updateAdminRoleState: ({ adminRoleManagement }) =>
        adminRoleManagement.apiState.updateAdminRole,
    }),
    routeName() {
      return this.$route.name;
    },
    adminRoleId() {
      return this.$route.params.id || undefined;
    },
    isEdit() {
      return Boolean(this.routeName === "admin-role-edit" && this.adminRoleId);
    },
  },
  methods: {
    ...mapActions({
      getAdminPermissions: "adminRoleManagement/getAdminPermissions",
      getAdminRole: "adminRoleManagement/getAdminRole",
      addAdminRole: "adminRoleManagement/addAdminRole",
      updateAdminRole: "adminRoleManagement/updateAdminRole",
    }),
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();

      if (isValid) {
        return this.submit();
      }

      return this.$vs.dialog({
        color: "danger",
        title: `Validation Error!`,
        text: "There is a error in this form",
      });
    },
    async submit() {
      return this.$vs.dialog({
        color: "primary",
        title: `Are you sure submit?`,
        text: "Continue submit",
        acceptText: "Yes",
        accept: () => {
          if (this.isEdit) {
            return this.updateAdminRole({
              id: this.adminRoleId,
              body: {
                ...this.form,
                permissions: this.form.permissions.map((id) => ({ id })),
                slug: snakeCase(this.form.name),
              },
            });
          }
          return this.addAdminRole({
            ...this.form,
            permissions: this.form.permissions.map((id) => ({ id })),
            slug: snakeCase(this.form.name),
          });
        },
      });
    },
  },
  async mounted() {
    await this.getAdminPermissions();

    if (this.isEdit) {
      this.getAdminRole(this.adminRoleId).then(() => {
        this.form = {
          ...this.form,
          name: this.adminRole.name,
          description: this.adminRole.description,
          permissions: this.adminRole.permissions.map(({ id }) => id),
        };
      });
    }
  },
  watch: {
    "addAdminRoleState.success"(value) {
      if (value) {
        this.$vs.notify({
          title: "Success create!",
          color: "success",
          position: "top-center",
        });
        this.$router.push({ name: "admin-role" });
      }
    },
    "addAdminRoleState.error"(error) {
      if (error) {
        this.$vs.notify({
          title: "Error!",
          text: error.data.message,
          color: "danger",
          position: "top-center",
        });
      }
    },
    "updateAdminRoleState.success"(value) {
      if (value) {
        this.$vs.notify({
          title: "Successful update!",
          color: "success",
          position: "top-center",
        });
      }
    },
    "updateAdminRoleState.error"(error) {
      if (error) {
        this.$vs.notify({
          title: "Error!",
          text: error.data.message,
          color: "danger",
          position: "top-center",
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
